import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import "../styles/fancybox-brand.scss";

function initBodytextGalleries() {
  document.querySelectorAll(".bodytext .gallery").forEach((gallery, index) => {
    const group = `bodytext-gallery-${index + 1}`;

    gallery.querySelectorAll(".gallery-icon a").forEach((link) => {
      link.setAttribute("data-fancybox", group);
    });
  });
}

initBodytextGalleries();

Fancybox.bind("[data-fancybox]", {
  theme: "light",
  hideScrollbar: false,
  mainClass: "fancybox-brand",
});
